import { fetchFactory } from 'isotope-client'

export const getExamensType = () => fetchFactory('/candidats/examensType', {}, '/api')
